exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-type[data-v-f94ec2b8] {\n    color: white;\n    font-size: 20px;\n}\n.pointer[data-v-f94ec2b8] {\n    cursor: pointer;\n}\n.block.address[data-v-f94ec2b8] {\n    font-size: 12px;\n    white-space: pre;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    font-weight: 600;\n    color: white;\n}\n", ""]);

// exports
